import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '../context/session-context';

const AuthProtectedRoute = () => {
  const { session } = useSession();
  if (!session) {
    return <Navigate to="/sign-in" replace />;
  }
  return <Outlet />;
};

export default AuthProtectedRoute;
